import { Link } from "react-router-dom";

export default function BlogCard({ post, featured = false }) {
  return (
    <Link
      to={`/blog/${post.slug}`}
      className={`group block bg-white rounded-2xl border border-slate-200 overflow-hidden transition duration-300
        hover:border-blue-500/40
        ${featured ? "md:grid md:grid-cols-2 md:gap-8 items-center" : ""}
      `}
    >
      {/* Image */}
      {post.cover_image && (
        <div className="overflow-hidden">
          <img
            src={post.cover_image}
            alt={post.title}
            className={`w-full object-cover transition duration-500 group-hover:scale-105
              ${featured ? "h-full md:h-[300px]" : "h-52"}
            `}
          />
        </div>
      )}

      {/* Content */}
      <div className={`${featured ? "p-10" : "p-8"}`}>

        <p className="text-sm text-slate-500 mb-3">
          {new Date(post.created_at).toLocaleDateString()}
        </p>

        <h2 className={`font-semibold text-slate-900 mb-4 leading-tight
          ${featured ? "text-3xl" : "text-xl"}
        `}>
          {post.title}
        </h2>

        {post.excerpt && (
          <p className="text-slate-600 leading-relaxed mb-6 line-clamp-3">
            {post.excerpt}
          </p>
        )}

        <span className="text-blue-600 font-medium text-sm group-hover:underline">
          Read Article →
        </span>

      </div>

      <p className="text-sm text-slate-500 mb-2">
        {new Date(post.created_at).toLocaleDateString()} • {post.readingTime} min read
      </p>

      <div className="flex gap-2 flex-wrap mb-3">
        {post.tags?.map((tag, i) => (
          <span key={i} className="text-xs bg-slate-100 px-2 py-1 rounded">
            {tag}
          </span>
        ))}
      </div>

    </Link>
  );
}